export const environment: 'production' | 'development' = 'production'

export default {
  /*
    Em **desenvolvimento** preencher API_URL com endereço do integra exemplo http://localhost:5002.
    Antes de gerar o build o valor da API_URL deve ser removido e mantido em branco para que o build
    ocorra de forma correta.
  */
  API_URL: environment === 'development' ? 'http://localhost:5002' : '',
  API_LOGIN_URL: 'https://login.insidesistemas.com.br',
  API_LOGIN_IDENTIFICADOR_APP: '226f8ce0-d48e-4af7-8f54-2d02cfdbe587',
  CLARITY_KEY: 'hr379143ky',
  METRICS_LOG_IN_OUT: 'https://servicewebmetrics.azurewebsites.net',
  FIREBASE_PUBLIC_KEY_VAPID: 'BBV7B9l_nBEBZbR4KvX67cD9eVUcELSOsbd3OOa5MuLgHWFFedo7cLHqiDSyDPK9G-7yTyLu79KV77o_0M7wJ7M'
}
